import React from 'react';
import { Dialog } from '@economic/taco';
import { t, Trans } from '@lingui/macro';
import { useLocation } from 'react-router-dom';
import { useCurrentUser } from '@economic/react-app';

import ExternalLink from '../../../../../../../shared/components/ExternalLink';
import moneyflowLogo from '../../../../../../market/onboarding/Moneyflow/moneyflow-logo.svg';
import useAppSettings from '../../../../../../../shared/hooks/useAppSettings';
import MoneyflowOnboardDialogContent from './MoneyflowOnboardDialogContent';
import track from '../../../../../../../shared/util/utilities/mixpanel';

interface Props {
    onDone: () => void;
    onCancel: () => void;
}

export default function MoneyflowOnboardDialog({ onDone, onCancel }: Props) {
    const { set: setInvoiceDraftId } = useAppSettings('moneyflow-onboarding-invoiceDraftId');
    const location = useLocation();
    const user = useCurrentUser();

    const invoiceDraftId = location.state?.draftId;

    const openedFromInvoicePage = location.pathname.includes('/sales/invoicing/invoices');

    const handleStartOnboard = () => {
        track('moneyflow', 'teasermodal.onboard.clicked', {
            source: openedFromInvoicePage ? 'Sales' : 'Market',
        });
        if (!user.isAdministrator && invoiceDraftId) {
            setInvoiceDraftId({ invoiceDraftId });
        } else {
            setInvoiceDraftId({ undefined });
        }
        onDone();
    };

    return (
        <Dialog size="md" defaultOpen onClose={onCancel}>
            <Dialog.Content aria-label={t`Moneyflow onboard dialog`}>
                <Dialog.Title>
                    <Trans>Get Started with Instant Payment</Trans>
                </Dialog.Title>
                <div className="flex justify-center">
                    <p>
                        <Trans>
                            With Instant Payment, you will receive your money in the account as soon as you have sent the invoice
                            via e-conomic. The solution has been developed in collaboration with e-conomic's partner Moneyflow.{' '}
                            <ExternalLink
                                href={t`https://www.e-conomic.dk/funktioner/straksindbetaling`}
                                onClick={() =>
                                    track('moneyflow', 'teasermodal.discovermore.clicked', {
                                        source: openedFromInvoicePage ? 'Sales' : 'Market',
                                    })
                                }>
                                Discover more
                            </ExternalLink>
                        </Trans>
                    </p>
                </div>
                <MoneyflowOnboardDialogContent callbackFuntion={handleStartOnboard} />
                {/* invoiceDraftId && (
                    <div className="flex justify-end">
                        <Button onClick={handleDialogClose} className="">
                            <Trans>Close</Trans>
                        </Button>
                    </div>
                ) */}

                <Dialog.Footer className="flex justify-end bg-grey-100 -mb-6 -mx-6 px-6 py-4">
                    {/* invoiceDraftId && (
                        <Checkbox
                            checked={hideInstantPaymentOffers}
                            label={t`No thanks, please don't show Instant payment at this time.`}
                            onChange={checked => setHideInstantPaymentOffers(checked)}
                        />
                    ) */}
                    <div>
                        <Trans>Instant payment is provided by: </Trans>
                        <ExternalLink href={t`https://moneyflow.io`}>
                            <img className="h-3 inline ml-1" src={moneyflowLogo} />
                        </ExternalLink>
                    </div>
                </Dialog.Footer>
            </Dialog.Content>
        </Dialog>
    );
}
